import React from 'react';

import { formatDistanceToNowStrict } from 'date-fns'

export default function NiceDate({ t, className = '' }) {
  return <span className={className || 'small text-info'}>{formatDistanceToNowStrict(new Date(t))} ago</span>
}
